<div>
  <div class="color-selector-mode">
    <div class="color-selector-subtitle">
      <span>HEADER</span>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color fondo:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.header.background"
          [value]="custom_colors.header.background"
          [style.background]="custom_colors.header.background"
          [(colorPicker)]="custom_colors.header.background" />
      </div>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color titulo:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.header.title"
          [value]="custom_colors.header.title"
          [style.background]="custom_colors.header.title"
          [(colorPicker)]="custom_colors.header.title" />
      </div>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color subtitulo:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.header.subtitle"
          [value]="custom_colors.header.subtitle"
          [style.background]="custom_colors.header.subtitle"
          [(colorPicker)]="custom_colors.header.subtitle" />
      </div>
    </div>
  </div>
  <div class="color-selector-mode">
    <div class="color-selector-subtitle">
      <span>TOPBAR</span>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color fondo:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.topbar.background"
          [value]="custom_colors.topbar.background"
          [style.background]="custom_colors.topbar.background"
          [(colorPicker)]="custom_colors.topbar.background" />
      </div>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color text:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.topbar.text"
          [value]="custom_colors.topbar.text"
          [style.background]="custom_colors.topbar.text"
          [(colorPicker)]="custom_colors.topbar.text" />
      </div>
    </div>
  </div>
  <div class="color-selector-mode">
    <div class="color-selector-subtitle">
      <span>LINK</span>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color fondo:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.externalbtn.background"
          [value]="custom_colors.externalbtn.background"
          [style.background]="custom_colors.externalbtn.background"
          [(colorPicker)]="custom_colors.externalbtn.background" />
      </div>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color text:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.externalbtn.text"
          [value]="custom_colors.externalbtn.text"
          [style.background]="custom_colors.externalbtn.text"
          [(colorPicker)]="custom_colors.externalbtn.text" />
      </div>
    </div>
  </div>
  <div class="color-selector-mode">
    <div class="color-selector-subtitle">
      <span>POPUPS</span>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color fondo:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.popups.background"
          [value]="custom_colors.popups.background"
          [style.background]="custom_colors.popups.background"
          [(colorPicker)]="custom_colors.popups.background" />
      </div>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color etiqueta:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.popups.tag"
          [value]="custom_colors.popups.tag"
          [style.background]="custom_colors.popups.tag"
          [(colorPicker)]="custom_colors.popups.tag" />
      </div>
    </div>
    <div class="color-selector-row">
      <div>
        <span class="me-3">Color valor:</span>
      </div>
      <div>
        <input
          class="colorpicker-input"
          [(ngModel)]="custom_colors.popups.value"
          [value]="custom_colors.popups.value"
          [style.background]="custom_colors.popups.value"
          [(colorPicker)]="custom_colors.popups.value" />
      </div>
    </div>
  </div>
</div>

<div class="color-apply-container">
  <button
    class="btn-secondary-action"
    *ngIf="template && !deleting"
    (click)="udpdateTemplate(custom_colors)"
    [disabled]="uploading"
    title="Guardar cambios de la plantilla">
    <span *ngIf="!uploading; else loading">Guardar</span>
    <ng-template #loading>
      <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
    </ng-template>
  </button>
  <button
    class="btn-secondary-action"
    *ngIf="!template && !createNewTemplate.values"
    (click)="createNewTemplate.values = custom_colors">
    Nueva plantilla
  </button>
  <button
    class="btn-secondary-action ms-2"
    *ngIf="!createNewTemplate.values && !deleting"
    (click)="applyCustomStyles()"
    title="Aplicar cambios en el site">
    Aplicar
  </button>
  <button
    class="btn-secondary-action"
    *ngIf="template && !deleting"
    (click)="deleting = true"
    class="btn-secondary-action ms-auto">
    Eliminar
  </button>
</div>

<div *ngIf="deleting" class="template-confirm-wrapper">
  <div>
    <span>Esta acción no se podrá deshacer.</span><br />
    <span>¿Eliminar plantilla?</span>
  </div>
  <div class="confirm-btns d-flex align-items-center justify-content-between">
    <button class="btn-secondary-action" (click)="destroyTemplate()">Si</button>
    <button class="btn-secondary-action" (click)="deleting = false">No</button>
  </div>
</div>

<div *ngIf="createNewTemplate.values" class="template-confirm-wrapper">
  <div>
    <span>Crear nueva plantilla</span>
  </div>
  <div class="d-flex align-items-center justify-content-between">
    <input type="text" class="custom-input mt-0" [(ngModel)]="createNewTemplate.name" />
    <button
      class="btn-secondary-action"
      (click)="createTemplate(createNewTemplate)"
      [disabled]="!createNewTemplate.name">
      <i class="fa fa-save"></i>
    </button>
    <button class="btn-secondary-action" (click)="createNewTemplate.values = null">
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>
